import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SsoService {
  constructor(private auth: AuthService, private afs: AngularFirestore) {}

  /**
   * Generates a unique handshake ID, writes it to Firestore,
   * and opens the target application in a new browser tab with the handshakeId as a query parameter.
   * @param targetApp Target sibling application to launch
   */
  public launchApp(targetApp: 'contactPro' | 'insightVue'): void {
    const user = this.auth.getUserAccount();
    if (!user) {
      console.warn('[SsoService] No user logged in for SSO launch');
      return;
    }

    const uid = user.uid;
    const handshakeId = this.afs.createId();

    const handshakeData = {
      uid,
      createdAt: Date.now(),
      used: false,
      sourceApp: 'provider-app',
      targetApp,
    };

    this.afs
      .collection('sso_handshake')
      .doc(handshakeId)
      .set(handshakeData)
      .then(() => {
        let targetUrl = '';
        if (targetApp === 'contactPro') {
          targetUrl = (environment as any).contactProUrl;
        } else if (targetApp === 'insightVue') {
          targetUrl = (environment as any).insightVueUrl;
        }

        if (!targetUrl) {
          console.error(`[SsoService] Target URL not configured for app: ${targetApp}`);
          return;
        }

        const ssoUrl = `${targetUrl}/sso-login?handshakeId=${handshakeId}`;
        window.open(ssoUrl, '_blank');
      })
      .catch((error) => {
        console.error('[SsoService] Error creating SSO handshake document:', error);
      });
  }
}
